import SearchViewState from '../../store/schema/SearchViewState';
import { getFilePickerStore } from '../../store/filePickerStore';
import { orchestrator } from 'satcheljs';
import { clearSearchBox, SearchScenarioId } from 'owa-search';

export const exportOnlyForTest = orchestrator(clearSearchBox, actionMessage => {
    if (actionMessage.scenarioId != SearchScenarioId.FilesPicker) {
        return;
    }

    const searchViewState: SearchViewState = getFilePickerStore().viewState.filePickerViewState
        .searchViewState;
    searchViewState.searchQuery = '';
    searchViewState.isInSearchMode = false;
});
